import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { Info, X } from 'lucide-react';

const InfoTooltip = ({ className, tooltip, mobileTooltip, color, hoverColor, children, title, position }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return (
    <div className={`${className} relative inline-flex items-center`}>
      <button
        type="button"
        tabIndex={-1}
        className={`${children ? '' : `text-${color} hover:text-${hoverColor}`} transition-colors cursor-pointer`}
        onMouseEnter={() => !isMobile && setShowTooltip(true)}
        onMouseLeave={() => !isMobile && setShowTooltip(false)}
        onClick={() => isMobile && setShowTooltip(true)}
        aria-label="tooltip"
      >
        {children || <Info size={14} />}
      </button>
      {showTooltip && !isMobile && tooltip && (
        <div className={`absolute left-1/2 transform -translate-x-1/2 ${position === 'bottom' ? 'top-full mt-2' : 'bottom-full mb-2'} py-2 text-sm text-gray-700 bg-white border border-gray-200 rounded-lg shadow-lg whitespace-nowrap z-10`}>
          {title ? (
            <div className="py-2 px-3 border-b border-gray-200">
              <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
            </div>
          ) : null}
          <div className="px-3">
            {tooltip}
          </div>
          {position === 'bottom' ? (
            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-b-4 border-transparent border-b-white" />
          ) : (
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-white" />
          )}
        </div>
      )}
      {showTooltip && isMobile && tooltip && (
        <div className="fixed inset-0 z-[351] flex items-end justify-center bg-black bg-opacity-50" onClick={() => setShowTooltip(false)}>
          <div className="w-full max-w-md bg-white rounded-t-lg shadow-lg" onClick={e => e.stopPropagation()}>
            <div className={`px-4 py-3 ${title ? 'border-b border-gray-200' : ''} flex items-center justify-between gap-2`}>
              <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
              <button onClick={() => setShowTooltip(false)} className="text-gray-400 hover:text-gray-600 transition-colors" aria-label="Close"><X className="w-4 h-4" /></button>
            </div>
            <div className="px-4 pt-2 pb-3 text-sm text-gray-700">{mobileTooltip || tooltip}</div>
          </div>
        </div>
      )}
    </div>
  );
};

InfoTooltip.propTypes = {
  tooltip: PropTypes.string.isRequired,
  mobileTooltip: PropTypes.node,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string,
  position: PropTypes.oneOf(['top', 'bottom']),
};

InfoTooltip.defaultProps = {
  color: 'gray-400',
  hoverColor: 'gray-600',
  className: '',
  title: '',
  position: 'top',
};

export default InfoTooltip;
